import React, { useEffect, useState, Fragment } from 'react';
const comparisonRows = [{
  without: '100+ horas/año buscando resúmenes dispersos',
  with: 'Todo organizado por materia en un solo lugar'
}, {
  without: 'Estudiás de cero cada parcial',
  with: '6 tomos con protocolos y resúmenes listos'
}, {
  without: 'Finales que se acumulan sin saber por dónde empezar',
  with: 'Guía de estudio por materia + banco de preguntas'
}, {
  without: 'TPs y prácticos que te llevan horas',
  with: 'Fichas de evaluación para adaptar en 20 min'
}, {
  without: 'Parámetros de electroterapia en 5 libros distintos',
  with: 'Tablas de referencia en una sola hoja'
}, {
  without: 'Materias recursadas por falta de estructura',
  with: 'Sistema de estudio inverso → aprobás de primera'
}, {
  without: 'Sin saber qué te van a tomar en el final',
  with: 'Banco de preguntas armado con lo que más toman'
}, {
  without: 'Te recibís sin saber cómo arrancar',
  with: 'Máster Kinesiología listo para el día uno'
}, {
  without: 'Sin identidad profesional ni sistema de cobro',
  with: 'Contrato + reglamento + presencia digital listos'
}];
const TIMER_KEY = 'megapack_kinesiologia_countdown_end';
const DURATION_MS = 24 * 60 * 60 * 1000;
function getEndTime(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = localStorage.getItem(TIMER_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + DURATION_MS;
  localStorage.setItem(TIMER_KEY, String(end));
  return end;
}
function getTimeLeft(endTime: number) {
  const diff = Math.max(0, endTime - Date.now());
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(diff % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
}
export function DarkCTA() {
  const [endTime] = useState<number>(() => getEndTime());
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(endTime));
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft(endTime));
    }, 1000);
    return () => clearInterval(timer);
  }, [endTime]);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-16 sm:py-20 text-gray-900 text-base leading-6" style={{
    background: 'linear-gradient(180deg, rgb(219,234,254) 0%, rgb(255,255,255) 30%, rgb(255,255,255) 70%, rgb(219,234,254) 100%)'
  }} data-id="element-78">
      <div className="mx-auto max-w-4xl text-center" data-id="element-79">
        {/* Brand */}
        <div className="mb-8 sm:text-3xl font-black tracking-[3px] text-blue-700 text-[18px]" data-id="element-80">
          🦴 MEGAPACK KINESIOLOGÍA CARRERA RESUELTA™
        </div>

        {/* Headlines */}
        <h2 className="text-xl sm:text-3xl font-bold text-gray-900 m-0 mb-3" data-id="element-81">
          El próximo parcial podés volver a improvisar.
        </h2>
        <p className="text-xl sm:text-3xl font-black text-blue-700 m-0 mb-10" data-id="element-82">
          O podés entrar con todo resuelto desde hoy.
        </p>

        {/* Comparison Table */}
        <div className="mx-auto max-w-2xl mb-12 overflow-hidden rounded-2xl border border-gray-200 text-left" style={{
        backgroundColor: 'rgb(255,255,255)'
      }} data-id="element-83">
          {/* Table Title */}
          <div className="text-center font-bold text-gray-900 border-b border-gray-200 px-4 py-4" style={{
          backgroundColor: 'rgb(243,244,246)'
        }} data-id="element-84">
            ¿Cuánto cuesta NO tenerlo?
          </div>

          {/* Table Header */}
          <div className="grid grid-cols-2 border-b border-gray-200" style={{
          backgroundColor: 'rgb(243,244,246)'
        }} data-id="element-85">
            <div className="text-center font-bold text-gray-500 px-4 py-3 text-sm" data-id="element-86">
              SIN MEGAPACK
            </div>
            <div className="text-center font-bold text-blue-700 border-l border-gray-200 px-4 py-3 text-sm" data-id="element-87">
              CON MEGAPACK
            </div>
          </div>

          {/* Rows */}
          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-88">
              <div className="px-4 py-3 text-xs sm:text-sm text-gray-500" data-id="element-89">
                ✗ {row.without}
              </div>
              <div className="px-4 py-3 text-xs sm:text-sm font-bold text-gray-900 border-l border-gray-100" style={{
            backgroundColor: 'rgba(59,130,246,0.05)'
          }} data-id="element-90">
                ✓ {row.with}
              </div>
            </div>)}
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-91">
          <p className="font-bold text-gray-900 m-0 mb-4" data-id="element-92">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-center justify-center gap-0" data-id="element-93">
            {[{
            value: timeLeft.hours,
            label: 'hs'
          }, {
            value: timeLeft.minutes,
            label: 'min'
          }, {
            value: timeLeft.seconds,
            label: 'seg'
          }].map((item, i) => <Fragment key={item.label} data-id="element-94">
                <div className="flex flex-col items-center" data-id="element-95">
                  <span className="text-5xl sm:text-7xl font-black tabular-nums" style={{
                color: 'rgb(255,68,68)'
              }} data-id="element-96">
                    {pad(item.value)}
                  </span>
                  <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-97">
                    {item.label}
                  </span>
                </div>
                {i < 2 && <span className="mb-4 text-5xl sm:text-7xl font-black" style={{
              color: 'rgb(255,68,68)'
            }} data-id="element-98">
                    :
                  </span>}
              </Fragment>)}
          </div>
        </div>

        <p className="text-sm text-gray-600 m-0 mb-12" data-id="element-99">
          Después sube{' '}
          <span className="font-bold text-red-500" data-id="element-100">$15.000 ARS</span> y no
          vuelve.
        </p>

        {/* Two Pricing Cards */}
        <div className="mx-auto max-w-2xl mb-10 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-101">
          {/* Standard */}
          <div className="flex flex-col rounded-xl p-6 border border-gray-200 shadow-sm" style={{
          backgroundColor: 'rgb(255,255,255)'
        }} data-id="element-102">
            <div className="mb-2 text-2xl" data-id="element-103">🦴</div>
            <h3 className="text-base font-black text-gray-900 m-0 mb-1" data-id="element-104">
              MEGAPACK KINESIOLOGÍA CARRERA RESUELTA
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-105">
              6 Tomos + 6 Bonos · Toda la carrera organizada
            </p>
            <div className="mt-auto" data-id="element-106">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-107">
                Antes: $58.990 ARS
              </p>
              <p className="text-2xl font-black text-blue-700 m-0 mb-4" data-id="element-108">
                Hoy: $19.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48273779458218:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Megapack Kinesiología Carrera Resuelta',
                  content_category: 'Kinesiología Carrera Resuelta',
                  value: 19990,
                  currency: 'ARS'
                });
              }
            }} className="block bg-blue-700 text-white text-center text-sm font-black rounded-lg py-4 no-underline hover:opacity-90 transition-opacity" data-id="element-109">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          {/* Pro */}
          <div className="flex flex-col rounded-xl p-6 border-2 border-blue-700 shadow-sm" style={{
          backgroundColor: 'rgb(239,246,255)',
          boxShadow: 'rgba(59,130,246,0.15) 0px 0px 30px 0px'
        }} data-id="element-110">
            <div className="mb-2 text-2xl" data-id="element-111">🏆</div>
            <h3 className="text-base font-black text-blue-700 m-0 mb-1" data-id="element-112">
              MEGAPACK + MÁSTER KINESIOLOGÍA ⭐
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-1" data-id="element-113">La más elegida</p>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-114">
              6 Tomos + 6 Bonos + Máster Kinesiología™
              <br data-id="element-115" />
              (consultorio, cobro, gestión y presencia digital)
            </p>
            <div className="mt-auto" data-id="element-116">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-117">
                Antes: $102.990 ARS
              </p>
              <p className="text-3xl font-black text-blue-700 m-0 mb-4" data-id="element-118">
                Hoy: $27.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48273779523754:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Megapack + Máster Kinesiología',
                  content_category: 'Kinesiología Carrera Resuelta',
                  value: 27990,
                  currency: 'ARS'
                });
              }
            }} className="block bg-blue-700 text-white text-center text-sm font-black rounded-lg py-4 no-underline hover:opacity-90 transition-opacity" data-id="element-119">
                → QUIERO EL MEGAPACK + MÁSTER KINESIOLOGÍA
              </a>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-600" data-id="element-120">
          <span data-id="element-121">🔒 Pago 100% seguro</span>
          <span data-id="element-122">⚡ Acceso en 5 minutos</span>
          <span data-id="element-123">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-124">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
      </div>
    </section>;
}